import { render, staticRenderFns } from "./DashboardLayoutMarketAnnoncer.vue?vue&type=template&id=188493f6&"
import script from "./DashboardLayoutMarketAnnoncer.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutMarketAnnoncer.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLayoutMarketAnnoncer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports